import * as React from 'react';
import clsx from 'clsx';

import {
  withStyles,
  WithStyles,
  AppBar as UnifiAppBar,
  Toolbar,
  IconButton,
} from '@nelnet/unifi-components-react';

import { Menu as MenuIcon } from '@material-ui/icons';

import Breadcrumbs from '../../modules/Breadcrumbs';

import styles from './styles/appbarstyles';
import usePlatform from '../../hooks/usePlatform';
import PlatformNav from './PlatformNav';

interface IAppBarProps extends WithStyles<typeof styles> {
  path: string;
  title: string;
  onOpen: () => void;
}

const AppBar: React.FunctionComponent<IAppBarProps> = ({ classes, path, title, onOpen }) => {
  const platform = usePlatform(path);

  const handleDrawerOpen = () => {
    onOpen();
  };

  return (
    <UnifiAppBar
      position="absolute"
      className={clsx(
        classes.appBar,
        path === '' && classes.appBarHome,
        platform && classes[platform],
      )}
    >
      <Toolbar className={classes.toolBar}>
        <IconButton
          aria-label="Open drawer"
          onClick={handleDrawerOpen}
          margin={{ right: 2 }}
          className={classes.navIconHide}
          color="inherit"
        >
          <MenuIcon />
        </IconButton>
        <Breadcrumbs path={path} title={title} />
        <PlatformNav platform={platform} />
      </Toolbar>
    </UnifiAppBar>
  );
};

export default withStyles(styles)(AppBar);
